var map = {
	"./app-store-logo.png": "c466",
	"./google-play-logo.jpeg": "c867",
	"./logo.png": "cf05",
	"./styles/abstracts/_functions.scss": "a78b",
	"./styles/abstracts/_mixins.scss": "3871",
	"./styles/abstracts/_variables.scss": "211d",
	"./styles/base/_base.scss": "2e72",
	"./styles/base/_helpers.scss": "25a2",
	"./styles/base/_inputs.scss": "19c2",
	"./styles/base/_typography.scss": "6ef6",
	"./styles/main.scss": "2fb4",
	"./styles/vendors/_carousel.scss": "ce0f",
	"./styles/vendors/_vue-tostification.scss": "73d5",
	"./svg-icons/apple.svg": "bb76",
	"./svg-icons/cart.svg": "5fc8",
	"./svg-icons/check.svg": "c800",
	"./svg-icons/chevron-down.svg": "880b",
	"./svg-icons/clock.svg": "f627",
	"./svg-icons/close.svg": "0426",
	"./svg-icons/credit-card.svg": "dc50",
	"./svg-icons/delete.svg": "a063",
	"./svg-icons/edit.svg": "84c3",
	"./svg-icons/email-outline.svg": "62a8",
	"./svg-icons/email-solid.svg": "7277",
	"./svg-icons/email.svg": "d20d",
	"./svg-icons/facebook-circle.svg": "df61",
	"./svg-icons/facebook.svg": "8699",
	"./svg-icons/foursquare.svg": "c132",
	"./svg-icons/glovo.svg": "4694",
	"./svg-icons/google-original.svg": "c311",
	"./svg-icons/google.svg": "5d5c",
	"./svg-icons/hamburger.svg": "196c",
	"./svg-icons/history.svg": "d6bf",
	"./svg-icons/home.svg": "088f",
	"./svg-icons/instagram.svg": "19bd",
	"./svg-icons/location.svg": "518c",
	"./svg-icons/logout.svg": "157f",
	"./svg-icons/loyalty.svg": "756a",
	"./svg-icons/minus-circle.svg": "9f06",
	"./svg-icons/minus.svg": "0a43",
	"./svg-icons/next.svg": "2af4",
	"./svg-icons/notification.svg": "1972",
	"./svg-icons/password.svg": "9bcd",
	"./svg-icons/perfect-match.svg": "5e7d3",
	"./svg-icons/pinterest.svg": "8601",
	"./svg-icons/plus-circle.svg": "31d2",
	"./svg-icons/plus.svg": "4945",
	"./svg-icons/prev.svg": "3c45",
	"./svg-icons/search.svg": "0eeb",
	"./svg-icons/tripadvisor.svg": "9172",
	"./svg-icons/twitter.svg": "fea9",
	"./svg-icons/user-friends.svg": "f4e3",
	"./svg-icons/user.svg": "2f00",
	"./svg-icons/vegan.svg": "16a6",
	"./svg-icons/wheat.svg": "043c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";